import { NavLink, RouteProps } from 'react-router-dom'

import { IconType } from 'components/icons'
import { useTranslation } from 'utils/translation'

import { NavigationBar, NavigationItem, NavigationWrapper } from './styles'

type NavigationProps = {
  routes: Array<
    RouteProps & {
      i18nKey?: string
      icon?: IconType
    }
  >
}

export const NavigationLink = ({
  path,
  i18nKey,
  icon: Icon,
}: {
  path: string
  i18nKey: string
  icon: IconType
}) => {
  const { t } = useTranslation()
  return (
    <NavigationItem
      onClick={() => {
        if (window.location.pathname === path) {
          window.scrollTo({
            top: 0,
            behavior: 'smooth',
          })
        }
      }}
    >
      <NavLink
        onClick={(e) => {
          if (window.location.pathname === path) {
            e.preventDefault()
          }
        }}
        to={path}
        className={({ isActive }) => (isActive ? 'active' : undefined)}
      >
        <Icon size="small" />
        {t(i18nKey)}
      </NavLink>
    </NavigationItem>
  )
}

const makeNavigation = (arr: NavigationProps['routes']) => {
  return arr
    .map(({ path, i18nKey, icon }) => {
      if (!i18nKey || !path || !icon) return null
      return (
        <NavigationLink
          key={i18nKey}
          i18nKey={i18nKey}
          path={path}
          icon={icon}
        />
      )
    })
    .filter((item) => item !== null)
}

export const Navigation = ({ routes }: NavigationProps) => {
  return (
    <NavigationWrapper>
      <NavigationBar>
        <ul>{makeNavigation(routes)}</ul>
      </NavigationBar>
    </NavigationWrapper>
  )
}
